import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  PieChartOutlined,
  ReconciliationOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Col, Row, Tabs, TabsProps } from "antd";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Title from "../UI/Title/Title";
import "./styles.css";
import DashboardHistoryList from "./dashboardHistoryList";
import DashboardSummaryList from "./dashboardSummaryList";
import { RightTab } from "./SideTabs";
import { useTranslation } from "react-i18next";

const DashboardInventory = () => {
  const [open, setOpen] = useState(true);
  const [option, setOption] = useState("2");
  const [picker, setPicker] = useState("");
  const onChange = (key: string) => {};
  const { t } = useTranslation("common");
  // const resetFilters = () => {
  //   setTableKey((tableKey) => tableKey + 1);
  //   setSearchText("");
  // };
  const [searchText, setSearchText] = useState("");
  const [tableKey] = useState(0);
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div className="tab-items">
          <PieChartOutlined style={{ fontSize: "20px" }} />
          <p>{t("general-dashboard")}</p>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="tab-items">
          <ReconciliationOutlined style={{ fontSize: "20px" }} />
          <p>{t("summary")}</p>
        </div>
      ),
      children: (
        <DashboardSummaryList
          picker={picker}
          tableKey={tableKey}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      ),
    },
    {
      key: "4",
      label: (
        <div className="tab-items">
          <ShoppingOutlined style={{ fontSize: "20px" }} />
          <p>{t("items-history")}</p>
        </div>
      ),

      children: <DashboardHistoryList picker={picker} />,
    },
  ];
  const icons: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div className="tab-items">
          <PieChartOutlined
            style={{
              fontSize: "20px",

              margin: "auto",
            }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="tab-items">
          <ReconciliationOutlined
            style={{ fontSize: "20px", margin: "auto" }}
          />
        </div>
      ),
      children: (
        <DashboardSummaryList
          picker={picker}
          tableKey={tableKey}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      ),
    },
    {
      key: "4",
      label: (
        <div className="tab-items">
          <ShoppingOutlined style={{ fontSize: "20px", margin: "auto" }} />
        </div>
      ),
      children: <DashboardHistoryList picker={picker} />,
    },
  ];

  useEffect(() => {
    if (option === "2") {
      setPicker("week");
    } else if (option === "3") {
      setPicker("month");
    } else if (option === "4") {
      setPicker("year");
    } else {
      setPicker("");
    }
  }, [option]);
  return (
    <>
      <Row>
        <Col offset={2} span={22}>
          <Breadcrumb>
            <Breadcrumb.Item>{t("dashboard")}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="">{t("inventory")}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col offset={2} span={4}>
          <Title title={t("dashboard")} />
        </Col>
        <Col offset={13} span={5} pull={1}>
          <RightTab option={option} setOption={setOption} />
        </Col>
      </Row>
      <Row gutter={[0, 0]}>
        <Row>
          {open ? (
            <Col span={2}>
              <DoubleLeftOutlined
                onClick={() => setOpen((old) => !old)}
                style={{
                  fontSize: "18px",
                  color: "#162149",
                  float: "right",
                  marginTop: "20px",
                }}
              />
            </Col>
          ) : (
            <Col span={1}>
              <DoubleRightOutlined
                onClick={() => setOpen((old) => !old)}
                style={{
                  fontSize: "18px",
                  color: "#162149",
                  float: "right",
                  marginTop: "20px",
                }}
              />
            </Col>
          )}
          <Col span={24}>
            {open ? (
              <Tabs
                className="left-tab"
                defaultActiveKey="1"
                items={items}
                tabPosition="left"
                style={{ width: "100%", marginTop: "15px" }}
                onChange={onChange}
                tabBarStyle={{
                  width: "150px",
                  height: "70vh",
                  borderRight: "1px #A7A7A7 solid",
                }}
              />
            ) : (
              <Tabs
                className="left-tab"
                defaultActiveKey="1"
                items={icons}
                tabPosition="left"
                style={{ width: "100%", marginTop: "15px" }}
                onChange={onChange}
                tabBarStyle={{
                  height: "70vh",
                  borderRight: "1px #A7A7A7 solid",
                }}
              />
            )}
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default DashboardInventory;
